//External
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Select, { components } from "react-select";
import { getVehicalDetailData } from "store/actions";
//Internal
import { get_cookie } from "utils";

/*******************
@Purpose : Used for model select
@Parameter : {brandVehicleList,changeTimeBreakDown,selectedModal,setSelectedModal,setVehicalDetailData,}
@Author : INIC
******************/
function ModelSelect({
  brandVehicleList,
  changeTimeBreakDown,
  selectedModal,
  setSelectedModal,
  setVehicalDetailData,
  setStartDate,
  setEndDate,
  setStartDateTimeOptions,
  setStartTimeDefaultValue,
  setEndTimeDefaultValue,
  setNoSlotError,
  setNoVehicleError, setDateObj
}) {
  const { ValueContainer, Placeholder } = components;
  const dispatch = useDispatch();
  const [model, setModel] = useState([]);
  const [inputClicked, setInputClicked] = useState(false);

  /*******************
@Purpose : React Hook Used for get brand vehicle list
@Parameter : {}
@Author : INIC
******************/
  useEffect(() => {
    let makes = [];
    brandVehicleList &&
      brandVehicleList.map((brand) => {
        makes.push({
          value: brand.slug,
          label: brand.name,
          image: brand?.primary_image?.image?.thumb,
        });
      });
    setModel(makes);
  }, [brandVehicleList]);

  /*******************
@Purpose : React Hook Used for get vehicle detail data
@Parameter : {}
@Author : INIC
******************/
  useEffect(() => {
    if (selectedModal) {
      dispatch(
        getVehicalDetailData(
          get_cookie("currentLocationId"),
          selectedModal.value,
          false
        )
      ).then((res) => {
        setVehicalDetailData(res?.vehicle);
        changeTimeBreakDown(res?.vehicle);
      });
    }
  }, [selectedModal]);

  const CustomValueContainer = ({ children, ...props }) => {
    /*******************
   @purpose : Render HTML/ React Components
   @Author : INIC
   ******************/
    return (
      <ValueContainer {...props}>
        <Placeholder {...props} isFocused={props.isFocused}>
          {props.selectProps.placeholder}
        </Placeholder>
        {React.Children.map(children, (child) =>
          child && child.type !== Placeholder ? child : null
        )}
      </ValueContainer>
    );
  };

  /*******************
@Purpose :  Used for formate option label
@Parameter : {image, label }
@Author : INIC
******************/
  const formatOptionLabel = ({ image, label }) => (
    <div className="image-select__image-option">
      <span className="selected-img">
        <img src={image} width={"56px"} height="auto" alt={label} />
      </span>
      <span>{label}</span>
    </div>
  );

  /*******************
   @purpose : Render HTML/ React Components
   @Author : INIC
   ******************/
  return (
    <Select
      instanceId="makesId"
      className={`select-float mt-0 select-big-container carmodal-select ${inputClicked ? "modalFocus" : ""
        }`}
      classNamePrefix="select_float"
      menuPlacement="bottom"
      placeholder="Model*"
      isClearable={false}
      isSearchable={false}
      options={model}
      onChange={(e) => {
        setSelectedModal(e);
        setInputClicked(false);
        setStartDate("");
        setEndDate("");
        setNoSlotError("")
        setNoVehicleError("")
        setStartTimeDefaultValue(null)
        setEndTimeDefaultValue(null)
        setStartDateTimeOptions([]);
        setDateObj([
          {
            startDate: new Date(),
            endDate: new Date(),
            key: "selection",
          },
        ]);
      }}
      value={selectedModal}
      formatOptionLabel={formatOptionLabel}
      onFocus={() => setInputClicked(true)}
      onMenuOpen={() => setInputClicked(true)}
      onMenuClose={() => {
        setInputClicked(false);
      }}
      // components={{ ValueContainer: CustomValueContainer }}
      styles={{
        container: (provided, state) => ({
          ...provided,
          marginTop: 50,
        }),
        valueContainer: (provided, state) => ({
          ...provided,
          overflow: "visible",
        }),
        placeholder: (provided, state) => ({
          ...provided,
          position: "absolute",
          top: state.hasValue || state.selectProps.inputValue,
          transition: "top 0.2s, font-size 0.2s",
          fontSize: (state.hasValue || state.selectProps.inputValue) && 13,
        }),
      }}
    />
  );
}
export default ModelSelect;
